<div class="p-px-24 d-flex flex-column">
  <div class="d-flex justify-content-end pb-px-12 cursor-pointer">
    <svg-icon
      (click)="onDialogClose()"
      src="/assets/icons/close-modal-primary.svg"
      class="cursor-pointer"
    ></svg-icon>
  </div>
  <mat-tab-group
    mat-stretch-tabs="{{ false }}"
    mat-align-tabs="start"
    color="primary">

    <mat-tab label="Détails">
      <ng-container *ngIf="!loading">
        <div class="py-px-24 d-flex flex-column">
          <div class="mb-px-24 d-flex flex-column">
            <div class="fs-13 fw-3 text-neutral-dark">Nom</div>
            <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.name || 'N/A' }}</div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column gap-4 flex-grow-1">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Numéro de SIRET</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.numsiret || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Adresse e-mail</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.mailpersonnecontact || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Nombre total des salariés</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.nombresalaries || 'N/A' }}</div>
              </div>
            </div>
            <div class="d-flex flex-column gap-4 flex-grow-1">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Type établissement</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.typeetablissement || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Numéro Finess</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.numfiness || 'N/A' }}</div>
              </div>
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Nombre annuel de patients pris en charge</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.nombreannuelpatients || 'N/A' }}</div>
              </div>
            </div>
          </div>
          <div class="mt-px-24 d-flex flex-column">
            <div class="fs-13 fw-3 text-neutral-dark">Description</div>
            <div class="fs-16 fw-4 text-neutral-dark">{{ etb?.description || 'N/A' }}</div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="loading">
        <app-loader></app-loader>
      </ng-container>
    </mat-tab>

    <mat-tab label="Sites">
      <div class="py-px-24 d-flex flex-column gap-4">
        <ng-container *ngFor="let site of etb?.adresses">
          <div class="p-4 border border--1 rounded border-neutral-light-grey d-flex flex-row gap-4">
            <div class="w-25">
              <img class="w-100" src="{{getImage(site.firstPhoto || site.secondPhoto)}}">
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Nom</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ site?.name || 'N/A' }}</div>
              </div>
              <div class="mt-px-24 d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Adresse</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ site?.adress || 'N/A' }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="Personnes gestionnaires">
      <div class="py-px-24 d-flex flex-column gap-4">
        <ng-container *ngFor="let person of etb?.persons">
          <div class="p-4 border border--1 rounded border-neutral-light-grey d-flex flex-row gap-4">
            <div class="w-25">
              <img style="object-fit: cover;height: 100%;" class="w-100" src="{{getImage(person.photo1 || person.photo2)}}">
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Nom et prénom</div>
                <div
                  class="fs-16 fw-4 text-neutral-dark">{{ person?.civility + ' ' + person?.firstName + ' ' + person?.lastName || 'N/A' }}
                </div>
              </div>
              <div class="mt-px-24 d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Fonction</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ person?.fonction || 'N/A' }}</div>
              </div>
              <div class="mt-px-24 d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Numéro de téléphone</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ person?.numTel || 'N/A' }}</div>
              </div>
              <div class="mt-px-24 d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Adresse e-mail</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ person?.mail || 'N/A' }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="Service d'affectation">
      <div class="py-px-24 d-flex flex-column gap-4">
        <ng-container *ngFor="let srv of affectationList">
          <div class="p-4 border border--1 rounded border-neutral-light-grey d-flex flex-row gap-4">
            <div style="width: 30% !important;min-width: 30% !important;">
              <img style="object-fit: cover;" class="w-100" src="{{getImage(srv.firstServicePhoto || srv.secondServicePhoto || srv.thirdServicePhoto)}}">
            </div>
            <div class="d-flex flex-column">
              <div class="d-flex">
                <div class="d-flex flex-column gap-4 flex-grow-1">
                  <div class="d-flex flex-column">
                    <div class="fs-13 fw-3 text-neutral-dark">Nom</div>
                    <div class="fs-16 fw-4 text-neutral-dark">
                      {{ srv.name || 'N/A' }}
                    </div>
                  </div>
                  <div class="mt-px-24 d-flex flex-column">
                    <div class="fs-13 fw-3 text-neutral-dark">Type</div>
                    <div class="fs-16 fw-4 text-neutral-dark">{{ srv.serviceType || 'N/A' }}</div>
                  </div>
                </div>
                <div class="d-flex flex-column gap-4 flex-grow-1">
                  <div class="d-flex flex-column">
                    <div class="fs-13 fw-3 text-neutral-dark">Nombre de lits </div>
                    <div class="fs-16 fw-4 text-neutral-dark">{{ srv?.numberOfBedsOrRooms || 'N/A' }}</div>
                  </div>
                  <div class="mt-px-24 d-flex flex-column">
                    <div class="fs-13 fw-3 text-neutral-dark">Nombre de personnel</div>
                    <div class="fs-16 fw-4 text-neutral-dark">{{ srv?.numberOfStaffWorkingInService || 'N/A' }}</div>
                  </div>
                </div>
              </div>
              <div class="mt-px-24 d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Nombre de patients pris en charge par an</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ srv?.numberOfPatientsCaredForPerYear || 'N/A' }}</div>
              </div>
              <div class="mt-px-24 d-flex flex-column">
                <div class="fs-13 fw-3 text-neutral-dark">Description</div>
                <div class="fs-16 fw-4 text-neutral-dark">{{ srv?.serviceDescription || 'N/A' }}</div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
